<div class="conver-suggested-bottom" id="showSuggestion">
    <div class="vbm-suggest-inner">
        <ng-container>
            <div class="continue_header">
                <span class="channelTitle">{{bs.getResource('rbkey_SggstdLBL')}}({{suggestions['data'].length}})</span>
            </div>
            <div class="owl-slider" id='owl_div' style="display:none; padding-left:20px; padding-right:20px;">
                <div id="carousel" class="H_carousel owl-carousel ">
                    <ng-container *ngFor="let item of suggestions['data']">
                        <div class="item card_border" style="cursor:pointer">
                            <div (click)="OpenItem(item)">
                                <div [ngClass]="item | searchCard : 'iconbg'">
                                    <i [ngClass]="item | searchCard : 'icon'"></i><span
                                        class="item_label">{{item['LearningTypeItemId'] === 4 ?
                                        bs.getResource('rbkey_TrnngLBL') : item['ItemTypeName']}}</span>
                                </div>
                                <div class="center_icon_parent">
                                    <!-- <img src="{{bs.config.lmsBaseUrl + 'Control/ThumbnailGenerator.aspx?LoggedIn=0&Canvas=true&ImageWidth=198&ImageHeight=132&ImageFile=..'+ item.ItemThumbnailPath }}"
                                        [title]="item.CourseName" [alt]="item.CourseName"
                                        style="height: 132px; width: 198px; border-radius: 4px 4px 0px 0px;"> -->

                                        <img src="{{item.ItemThumbnailPath}}"
                                        [title]="item.CourseName" [alt]="item.CourseName"
                                        style="height: 132px; width: 198px; border-radius: 4px 4px 0px 0px;">
                                </div>
                                <div class="section_progress">
                                    <div class="slim">
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar"
                                                [attr.aria-valuenow]="item.Progress" aria-valuemin="0"
                                                aria-valuemax="100" [style.width]="item.Progress+'%'">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel_caption">
                                    <div class="wrap_txt"> {{item.CourseName}} </div>
                                    <div class="carousel_more" [style.color]="item['IsAssigned']? '#cf6679':'#03dac5'">
                                        {{ bs.getResource(item["IsAssigned"] ? 'rbkey_MndtryLBL' : 'rbkey_OptnlLbl')}}
                                    </div>
                                </div>
                            </div>
                            <a *ngIf="item['IsAccessed']" class="center_play_icon"><i class="center_play_circle"
                                    (click)="OpenItem(item)"></i></a>
                            <a *ngIf="!item['IsAccessed'] && !item['IsAssigned']" class="center_play_icon"><i class="center_catalog_icon"
                                    (click)="OpenItem(item)"></i></a>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</div>